import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromApp from './app.reducer';
import { AppState } from './app.state';

const selectAppState = createFeatureSelector<AppState>(fromApp.appFeatureKey);

export const getAccessToken = createSelector(selectAppState, state => state.accessToken);
export const getDirectoryId = createSelector(selectAppState, state => state.directoryId);
export const getUserName = createSelector(selectAppState, state => state.userName);
export const getImpersonation = createSelector(selectAppState, state => state.impersonation);